import { APIVersion, axios } from "../../Config/config.js";
const sharedBaseUrl = "https://shared.dev.silal.app";
// axios.defaults.baseURL = basePath;

// const getRequests = async (payload) => {
//   return await axios.get(
//     `${APIVersion}requests/?page=1&per_page=2000`,
//     payload
//   );
// };
const getRequests = async (payload) => {
  let url =
    "requests/?page=1&status=1&status=2&status=3&archived=&per_page=100000";
  if (payload) {
    payload.requests.forEach((req) => {
      url += `&request_type=${req}`;
    });
  }
  return await axios.get(`${APIVersion}${url}`, payload);
};
const getResponse = async (payload) => {
  return await axios.put(
    `${APIVersion}requests/${payload.id}/respond/`,
    payload
  );
};

const getSingleRequests = async (requestId) => {
  return await axios.get(`${APIVersion}requests/${requestId}/`);
};
export { getRequests, getResponse, getSingleRequests };
